"use client";

import { Button, ButtonProps } from "@faire/web/slate/Button";
import React from "react";
import { useHistory } from "react-router-dom";

import type { SignUpElement, SignUpType } from "@faire/retailer/lib/popSignUp";
import {
  getSignUpLink,
  trackSignUpClick,
} from "@faire/retailer/lib/popSignUpUtils";

export const SignUpButton: React.FC<{
  type: SignUpType;
  element: SignUpElement;
  sourceId: string;

  variant?: ButtonProps["variant"];
  style?: ButtonProps["style"];
  dataTestId?: string;

  children: React.ReactNode;
}> = ({ type, element, sourceId, variant, style, dataTestId, children }) => {
  const history = useHistory();
  const onSignUpClick = () => {
    trackSignUpClick(type, element, sourceId);
    history.push(getSignUpLink(type));
  };

  return (
    <Button
      onClick={onSignUpClick}
      variant={variant}
      style={style}
      data-test-id={dataTestId}
    >
      {children}
    </Button>
  );
};
